import { render } from "./commisionsList.vue?vue&type=template&id=e1c68696"
import script from "./commisionsList.vue?vue&type=script&lang=js"
export * from "./commisionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__